import React, { Component } from 'react';
import TrialForm from './trial-form';

class Trial extends Component {
  render() {
    return (
      <section className="aboss__body aboss__body-trial">
        <div className="aboss__trial-head">
          <TrialForm type='artist'/>

        </div>
      </section>
    );
  }
}

export default Trial;


// WEBPACK FOOTER //
// src/views/trial/index.js